import { createStandardAction } from 'typesafe-actions';

export const sampleSelectedProjectAction = createStandardAction(
  'SAMPLE_SELECTEDPROJECT_ACTION'
)<void>();

export const changeSelectedProjectAction = createStandardAction(
  'project/CHANGE_PROJECT'
)<string>();
